import React from 'react';
import { czDate, stepStatus } from '../../utils/deliveryApi';

// Dark header like the printed template + stepper: 0 Údaje, 1–7 steps, 8 Shrnutí (free navigation)
const WizardHeader = ({ protocol, definition, current, onGo }) => {
  const h = protocol.header || {};
  const slots = [
    { idx: 0, num: '00', label: 'Údaje', status: h.customer_name && h.serial_number && h.planned_date ? 'done' : 'partial' },
    ...definition.steps.map((s) => ({ idx: s.step, num: String(s.step).padStart(2, '0'), label: s.short, status: stepStatus(s, protocol) })),
    { idx: 8, num: '✓', label: 'Shrnutí', status: protocol.status === 'closed' ? 'done' : 'todo' },
  ];
  const phaseCols = { pred: '2 / 5', misto: '5 / 8', po: '8 / 9' };
  const statusText = { done: ' – hotovo', issue: ' – s výhradou', partial: ' – rozpracováno', todo: '' };
  return (
    <header>
      <div className="dlv-hero">
        <div className="dlv-hero__kicker">Checklist · Odvoz a předání</div>
        <h1 className="dlv-hero__title">{h.customer_name || 'Odvoz a předání trenažéru'}</h1>
        <div className="dlv-hero__meta">
          <span>Model <strong>{h.model || '—'}</strong></span>
          <span>SN <strong>{h.serial_number || '—'}</strong></span>
          <span>Termín odvozu <strong>{czDate(h.planned_date)}</strong></span>
          {h.install_address && <span>{h.install_address}</span>}
        </div>
        <div className="dlv-hero__badge">
          <span>Protokol č. {protocol.id}</span>
          <b style={{ color: protocol.status === 'closed' ? '#7ee07e' : '#fff' }}>{protocol.status === 'closed' ? 'Uzavřeno' : 'Rozpracováno'}</b>
        </div>
      </div>
      <nav className="dlv-stepper" aria-label="Kroky protokolu">
        {definition.phases.map((p) => <div key={p.key} className="dlv-phase" style={{ gridColumn: phaseCols[p.key] }}>{p.label}</div>)}
        {slots.map((s) => (
          <button key={s.idx} type="button" onClick={() => onGo(s.idx)} style={{ gridColumn: s.idx + 1 }}
            className={`dlv-step dlv-step--${s.status} ${current === s.idx ? 'dlv-step--active' : ''}`}
            aria-current={current === s.idx ? 'step' : undefined} aria-label={`${s.label}${statusText[s.status] || ''}`}>
            <span className="dlv-step__dot">{s.num}</span>
            <span className="dlv-step__label">{s.label}</span>
          </button>
        ))}
      </nav>
    </header>
  );
};

export default WizardHeader;
